import { useAccount } from '@bnnvara/accounts';
import { track } from '@bnnvara/analytics/src/track';
import getConfig from 'next/config';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import resizeImageSource from '../../../helpers/resizeImageSource';
import Header from '../Header';
import * as S from './styled';

const ProfileHeaderLoggedIn = forwardRef(({ textColor, page }, ref) => {
  const {
    publicRuntimeConfig: {
      account: { settingsUrl },
    },
  } = getConfig();
  const { profile } = useAccount();
  const mobileImage = page.backgroundImageMobile || page.backgroundImage;
  const description =
    'Dit is jouw plek op BNNVARA waar je jouw titels, likes, video’s en artikelen terug kan vinden. We werken aan meer mogelijkheden die je kunt gebruiken!';

  const headerButton = (
    <S.Button
      ref={ref}
      href={settingsUrl}
      size="small"
      type="link"
      variant="ghost"
      onClick={() => track('header', 'click', 'cta')}
    >
      Naar accountinstellingen
    </S.Button>
  );

  return (
    <Header
      backgroundImageUrl={page.backgroundImage}
      backgroundImageMobileUrl={mobileImage}
      title={page.title}
      subtitle={profile && profile.nickname}
      description={description}
      color={textColor}
      avatar={
        (profile && profile.profilePicture) ||
        resizeImageSource(page.logoUrl, 120)
      }
      customCtaButton={headerButton}
    />
  );
});

ProfileHeaderLoggedIn.defaultProps = {
  textColor: 'white',
  page: {
    callToActionText: null,
    callToActionUrl: null,
  },
};
ProfileHeaderLoggedIn.propTypes = {
  textColor: PropTypes.string,
  page: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    backgroundImage: PropTypes.string.isRequired,
    backgroundImageMobile: PropTypes.string.isRequired,
    logoUrl: PropTypes.string.isRequired,
    callToActionText: PropTypes.string,
    callToActionUrl: PropTypes.string,
  }),
};

export default ProfileHeaderLoggedIn;
